import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from 'src/pages/login';
import Disabled from '../../../pages/disabled';
import { AxiosInterceptorNavigate } from 'src/modules/axios-interceptor/axios-interceptor-navigate';
import UserAccess from 'src/pages/user-access';
import ClientView from 'src/pages/client-view';
import { Toaster } from 'src/modules/notification/ute-notifier';
import ThirdPartyAccessVerifiedContainer from 'src/pages/third-party-access-verified';
import AccessDeniedContainer from 'src/pages/access-denied';
import ThirdPartyLoginContainer from 'src/pages/third-party-au';
import LoggedOutContainer from 'src/pages/logged-out';
import Logout from 'src/pages/logout';

const LoggedOutUsers = () => {
	return (
		<Router>
			<AxiosInterceptorNavigate />
			<Routes>
				<Route
					path='/disabled'
					element={<Disabled />}
				/>
				<Route
					path='/third-party/access-verify/:auClientGuid'
					element={<ThirdPartyLoginContainer />}
				/>
				<Route
					path='/third-party/login/:auClientGuid'
					element={<ThirdPartyLoginContainer />}
				/>
				<Route
					path='/access/:productType/:companyId'
					element={<UserAccess />}
				/>
				<Route
					path='/clientview/:productType/:companyId/:cpaUserId'
					element={<ClientView />}
				/>
				<Route
					path='/third-party/access-verified/'
					element={<ThirdPartyAccessVerifiedContainer />}
				/>
				<Route
					path='/access-denied'
					element={<AccessDeniedContainer />}
				/>
				<Route
					path='/logged-out'
					element={<LoggedOutContainer />}
				/>
				<Route
					path='/logout/:companyId/:auRegistrationId'
					element={<Logout />}
				/>
				<Route
					path='/'
					element={<Login />}
				/>
				<Route
					path='*'
					element={
						<Navigate
							to='/'
							replace
						/>
					}
				/>
			</Routes>
			<Toaster />
		</Router>
	);
};

export default LoggedOutUsers;
